import { EventLog } from '@shared/modules/alerts/shared/event-log.model'
import { SosAlert } from './sos-alert.model'

// Maps an event-log detail record onto the subset of SosAlert fields it can enrich.
export function mapEventLogToSos(e: EventLog | undefined | null): Partial<SosAlert> {
  if (!e) return {}

  return {
    driver: e.triggeredDetails || undefined,
    vehicle: e.shortDetails?.vehicleRegNo || e.eventSource?.name || undefined,
    location: e.shortDetails?.address || undefined,
    lat: e.shortDetails?.lastCoordinates?.lat,
    lng: e.shortDetails?.lastCoordinates?.lng,
    vehicleId: e.eventSource?.vehicleId,
  }
}
